import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";
import { IGciTrackerSettings } from "../../../types/types";
import {
  gciTrackerSettingsLoading,
  gciTrackerSettingsLoadingError,
  gciTrackerSettingsLoaded,
  gciTrackerSettingsUpdating,
  gciTrackerSettingsUpdatingError,
  gciTrackerSettingsUpdated,
  clearGciTrackerError,
} from "./gciTrackerStateActions";

interface IGciTrackerState {
  settings: IGciTrackerSettings | null;
  loading: boolean;
  error: string | null;
  updating: boolean;
  loaded: boolean;
}

const initialState: IGciTrackerState = {
  settings: null,
  loading: false,
  error: null,
  updating: false,
  loaded: false,
};

const gciTrackerSlice = createSlice({
  name: "gciTracker",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
    builder
      .addCase(gciTrackerSettingsLoading, (state) => {
        state.loading = true;
        state.error = null;
        state.loaded = false;
      })
      .addCase(gciTrackerSettingsLoaded, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
        state.error = null;
        state.loaded = true;
      })
      .addCase(gciTrackerSettingsLoadingError, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.loaded = false;
      })
      .addCase(gciTrackerSettingsUpdating, (state) => {
        state.updating = true;
        state.error = null;
      })
      .addCase(gciTrackerSettingsUpdated, (state, action) => {
        state.updating = false;
        state.settings = action.payload;
        state.error = null;
      })
      .addCase(gciTrackerSettingsUpdatingError, (state, action) => {
        state.updating = false;
        state.error = action.payload;
      })
      .addCase(clearGciTrackerError, (state) => {
        state.error = null;
      });
  },
});

export default gciTrackerSlice.reducer;
